import { oembedUrl } from './OembedStore';

export const updateOembedUrl = (value) => oembedUrl.update((oldValue) => value);
